<template>
  <div 
  class="Button" :class="getTint()" @click="onClick()">
    {{ trans('Global.join') }}
  </div>
</template>

<script>

import gsap from "gsap"
import Settings from '@/config/Settings'

export default {

  name: 'Button',
  data: ()=>({
      mail: ''
  }),
  computed:{
      tint() { return this.$store.getters['commons/tint'] }
  },
  created() {
      this.mail = Settings.email
  },
  methods: {
    onClick() {

      let link = Settings.link['rwg']
      if(this.lang == 'fr')
        link += '/bienvenue'

      console.log(link);

      window.open(link, '_blank')
    },
    onCopy() {
      this.$store.commit('commons/ADD_ALERT', 'store')
    },
    getTint() {
      return this.tint
    }
  } 
}
</script>

<style lang='stylus'>

@import '~@/commons/stylus/Media-queries'
@import '~@/config/Settings'

.Button
  position relative 
 
</style>


